import axios from 'axios';

import { url } from './config';

const api = {
    getSchema(params) {
        return axios
            .get(`${url}/schema`, { params })
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    get(params) {
        return axios
            .get(`${url}`, { params })
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    getById(id, params) {
        return axios
            .get(`${url}/${id}`, { params })
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    post(body) {
        return axios
            .post(`${url}`, body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    put(body) {
        return axios
            .put(`${url}`, body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    }
};

export default api;
